/**
 * Mobile sticky Add-to-Cart bar. Slides up when the real add-to-cart button
 * scrolls out of view; its button triggers the real one (so variant + cart
 * drawer behaviour is reused). Desktop is display:none via CSS.
 */
(function () {
  function init() {
    var bar = document.querySelector('[data-sticky-atc]');
    if (!bar) return;
    var realBtn =
      document.querySelector('.product-form__submit') ||
      document.querySelector('product-form button[type="submit"]');
    if (!realBtn) return;

    var addBtn = bar.querySelector('[data-sticky-atc-add]');
    addBtn.addEventListener('click', function () {
      realBtn.click();
    });

    // Reflect sold-out / disabled state
    function syncState() {
      var disabled = realBtn.hasAttribute('disabled');
      addBtn.toggleAttribute('disabled', disabled);
      addBtn.textContent = disabled ? 'Sold out' : 'Add to cart';
    }
    syncState();
    new MutationObserver(syncState).observe(realBtn, {
      attributes: true,
      attributeFilter: ['disabled'],
    });

    // Keep the price in sync with the live product price if present
    var priceEl = bar.querySelector('[data-sticky-atc-price]');
    var livePrice = document.querySelector('.price__regular .price-item--regular');
    if (priceEl && livePrice) {
      new MutationObserver(function () {
        priceEl.textContent = livePrice.textContent.trim();
      }).observe(document.querySelector('.price') || livePrice, {
        subtree: true,
        childList: true,
        characterData: true,
      });
    }

    // Show the bar only once the real button has scrolled out of view
    var io = new IntersectionObserver(
      function (entries) {
        bar.classList.toggle('is-visible', !entries[0].isIntersecting);
      },
      { threshold: 0 }
    );
    io.observe(realBtn);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
